import type { InputHTMLAttributes } from 'react';

import { controlClass, type FieldSize } from './fieldControl';

export function Input({
  size = 'md',
  className = '',
  ...rest
}: { size?: FieldSize } & Omit<InputHTMLAttributes<HTMLInputElement>, 'size'>) {
  return <input className={controlClass(size, className)} {...rest} />;
}
